import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';

export interface EventPriceExtraOptionItem {
  id: number;
  label: string;
  is_active?: boolean;
  sort_order?: number;
  default_price?: number | null;
}

/**
 * Active price-extra catalog for add/edit-event and template admin.
 */
export function event_price_extra_options(service: ComponentDataSourceService): DataSourceFunction {
  return {
    name: 'event_price_extra_options',
    description: 'Organisationens aktive price-extras til event-formularen',
    execute: (_params?: LoadDataParams): Observable<{ items: EventPriceExtraOptionItem[]; totalCount: number }> => {
      return service.http
        .get<{ items?: EventPriceExtraOptionItem[]; totalCount?: number }>(
          `${environment.apiUrl}/events/price-extra-options`,
          { params: { activeOnly: 'true' } }
        )
        .pipe(
          map((res) => ({
            items: (res?.items ?? []) as EventPriceExtraOptionItem[],
            totalCount: res?.totalCount ?? (res?.items?.length ?? 0),
          })),
          catchError((error) => {
            console.error('[event_price_extra_options datasource] Error fetching price extras:', error);
            return of({ items: [], totalCount: 0 });
          })
        );
    },
  };
}
